import { render, staticRenderFns } from "./Register-new.vue?vue&type=template&id=33b40fb3&scoped=true"
import script from "./Register-new.vue?vue&type=script&lang=js"
export * from "./Register-new.vue?vue&type=script&lang=js"
import style0 from "./Register-new.vue?vue&type=style&index=0&id=33b40fb3&prod&scoped=true&lang=scss"
import style1 from "./Register-new.vue?vue&type=style&index=1&id=33b40fb3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b40fb3",
  null
  
)

export default component.exports